module.exports = __webpack_public_path__ + "img/icon_search_bottom.a8069cd6.png";